import { loadableWithFallback } from '@vision/ui/utils';
import type { GaugeChart1Props } from './GaugeChart1';

export const GaugeChart1 = loadableWithFallback<GaugeChart1Props>(() => import('./GaugeChart1'));
